import { type ReactNode, useMemo } from 'react';
import { AuthContext, type CurrentUser } from '@/lib/auth';

export function AuthProvider({
  user,
  children,
}: {
  user: CurrentUser | null;
  children: ReactNode;
}) {
  const value = useMemo(() => ({ user }), [user]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
